/* storybook-check-ignore */
export default function BackOutIcon({
  color = '#082DE6',
  size = 16,
}: {
  color?: string;
  size?: number | string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <rect width="16" height="16" transform="translate(0 0.000488281)" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 2.00049C2.89543 2.00049 2 2.89592 2 4.00049V13.0004C2 14.105 2.89543 15.0004 4 15.0004H11.3496C12.4542 15.0004 13.3496 14.105 13.3496 13.0004V4.00049C13.3496 2.89592 12.4542 2.00049 11.3496 2.00049H4ZM10.2857 11.473L8.26397 9.30499H13.3485V7.80499H8.26397L10.2857 5.63699L9.18868 4.61398L5.51356 8.55499L9.18868 12.496L10.2857 11.473Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
